import SessionAnalysisCard from "@memorang/ui/components/Cards/SessionAnalysisCard";
import { useTranslation } from "react-i18next";

type Props = {
	sessionAnalysis?: string;
	loading?: boolean;
	toggleShowCompleteReport: () => void;
	appFont?: string;
};

const SessionAnalysisCardContainer = ({
	sessionAnalysis = "",
	loading = false,
	toggleShowCompleteReport,
	appFont,
}: Props) => {
	const { t } = useTranslation();

	const truncatedText =
		sessionAnalysis?.length > 400
			? `${sessionAnalysis?.substring(0, 330)}...`
			: sessionAnalysis;

	return (
		<SessionAnalysisCard
			title={t("report.sessionAnalysis.title")}
			subtitle={t("report.sessionAnalysis.subtitle")}
			buttonText={t("report.sessionAnalysis.viewFullAnalysis")}
			sessionAnalysis={truncatedText}
			loading={loading}
			onToggleCompleteReport={toggleShowCompleteReport}
			appFont={appFont}
		/>
	);
};

export default SessionAnalysisCardContainer;
